/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc チャット開始パネル
 *
 * @author genka
 * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
 */
<template>
<el-container class="fc-chat-join-pane">

  <el-main class="main-area">
    <p class="information-text" v-show="userCertificateFlg">{{$t('基本情報を入力し「チャットを始める」ボタンをクリックしてください。')}}</p>
    <p class="information-text" v-show="!userCertificateFlg">{{$t('氏名(カナ)を入力し「チャットを始める」ボタンをクリックしてください。')}}</p>
    <el-form ref="fastchatUserInfoForm" :model="fastchatUserInfo" :rules="userCertificateFlg ? rulesCertificate : rulesNoCertificate" @submit.native.prevent="doChatJoin">
      <el-form-item class="form-item" :label="$t('氏名(カナ)')" required></el-form-item>
      <div style="display: flex">
        <el-form-item prop="lnameKana" class="form-item">
          <el-input type="text" class="name-input" :maxlength="200" size="small" :disabled="!permissionInputFastchatUserInfoForm" v-model="fastchatUserInfo.lnameKana" :placeholder="$t('セイ')"></el-input>
        </el-form-item>
        <el-form-item prop="fnameKana" class="form-item fname-kana-form-item">
          <el-input type="text" class="name-input" :maxlength="200" size="small" :disabled="!permissionInputFastchatUserInfoForm" v-model="fastchatUserInfo.fnameKana" :placeholder="$t('メイ')"></el-input>
        </el-form-item>
      </div>
     <el-form-item :label="$t('SIM電話番号')" class="form-item cust-tel-form-item" v-show="userCertificateFlg" prop="custTel">
        <el-input type="tel" class="name-input cust-tel-input" :maxlength="64" size="small" :disabled="!permissionInputFastchatUserInfoForm" v-model="fastchatUserInfo.custTel" :placeholder="$t('09012345678')"></el-input>
      </el-form-item>
      <el-form-item class="form-item" :label="$t('生年月日')" v-show="userCertificateFlg" required></el-form-item>
      <div style="display: flex" v-show="userCertificateFlg">
        <el-form-item prop="year" class="form-item">
          <el-select  ref="yearSelect" class="birthday-select-year" size="small" :disabled="!permissionInputFastchatUserInfoForm" v-model="fastchatUserInfo.year" @focus="birthdayFocusHandler" @change="yearsMonthsChangeHandler" placeholder="">
            <el-option v-for="item in years" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <span>{{$t('年')}}</span>
        </el-form-item>
        <el-form-item prop="month" class="form-item">
          <el-select class="birthday-select-month" size="small" :disabled="!permissionInputFastchatUserInfoForm" v-model="fastchatUserInfo.month" @focus="birthdayFocusHandler" @change="yearsMonthsChangeHandler" placeholder="">
            <el-option v-for="item in months" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <span>{{$t('月')}}</span>
        </el-form-item>
        <el-form-item prop="day" class="form-item">
          <el-select class="birthday-select-day" size="small" :disabled="!permissionInputFastchatUserInfoForm" v-model="fastchatUserInfo.day" @focus="birthdayFocusHandler" placeholder="">
            <el-option v-for="item in days" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <span>{{$t('日')}}</span>
        </el-form-item>
      </div>
    </el-form>
    <p class="user-certificate-explanation" v-show="userCertificateFlg" v-text="userCertificateExplanation"></p>
  </el-main>

  <el-user-certificate-result-dialog ref="userCertificateResultDialog" v-show="showUserCertificateResultDialogFlg" @showUserCertificate="showUserCertificateHandler" @showUserNoCertificate="showUserNoCertificateHandler">
  </el-user-certificate-result-dialog>

  <el-footer class="footer-area" height="auto">
    <el-button type="primary" class="chat-join-button" :disabled="!permissionChatJoin" @click="doChatJoin">{{$t('チャットを始める')}}</el-button>
  </el-footer>

</el-container>
</template>

<script>
import {
  Container,
  Main,
  Footer,
  Form,
  FormItem,
  Input,
  Button,
  Select,
  Option
} from 'element-ui'
import ServiceUtil from '@/utils/ServiceUtil'
import ChatMessageConst from '@/constants/ChatMessageConst'
import ChatConst from '@/constants/ChatConst'
import DialogUtil from '@/utils/DialogUtil'
import DateUtil from '@/utils/DateUtil'
import FcChatUserCertificateResultDialog from './dialog/FcChatUserCertificateResultDialog'

export default {
  name: 'FcChatJoinPane',
  components: {
    'el-container': Container,
    'el-main': Main,
    'el-footer': Footer,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-button': Button,
    'el-select': Select,
    'el-option': Option,
    'el-user-certificate-result-dialog': FcChatUserCertificateResultDialog
  },
  data() {
    return {
      /**
       * FastChatユーザー情報
       * @type {Object}
       */
      fastchatUserInfo: {
        /**
         * 氏名(カナ)‐セイ
         * @type {String}
         */
        lnameKana: '',
        /**
         * 氏名(カナ)‐メイ
         * @type {String}
         */
        fnameKana: '',
        /**
         * 電話番号
         * @type {Number}
         */
        custTel: null,
        /**
         * 生年月日‐年
         * @type {String}
         */
        year: null,
        /**
         * 生年月日‐月
         * @type {String}
         */
        month: null,
        /**
         * 生年月c‐月
         * @type {String}
         */
        day: null
      },
      rulesCertificate: {
        lnameKana: [{
          required: true,
          message: ' ',
          trigger: 'blur'
        }],
        fnameKana: [{
          required: true,
          message: ' ',
          trigger: 'blur'
        }],
        custTel: [{
          required: true,
          message: ' ',
          trigger: 'blur'
        }, {
          pattern: /^[0-9]*$/,
          message: this.$t('半角数字で入力してください'),
          trigger: 'blur'
        }],
        year: [{
          required: true,
          message: ' ',
          trigger: 'blur'
        }],
        month: [{
          required: true,
          message: ' ',
          trigger: 'blur'
        }],
        day: [{
          required: true,
          message: ' ',
          trigger: 'blur'
        }]
      },
      rulesNoCertificate: {
        lnameKana: [{
          required: true,
          message: ' ',
          trigger: 'blur'
        }],
        fnameKana: [{
          required: true,
          message: ' ',
          trigger: 'blur'
        }]
      },
      /**
       * チャットユーザー情報のvalid状態
       * @type {Boolean}
       */
      validFastchatUserInfo: false,
      /**
       * FastChatサービス状態取得サービスをリクエスト中か
       * @type {Boolean}
       */
      requestingFindFastchatServiceStatus: false,
      /**
       * 無効状態
       * @type {Boolean}
       */
      disabled: false,
      /**
       * ユーザ認証フラグ
       * @type {Boolean}
       */
      userCertificateFlg: false,

      /**
       * ユーザ認証結果ダイアログの表示
       * @type {Boolean}
       */
      showUserCertificateResultDialogFlg: false,

      /**
       * ユーザ認証失敗回数
       * @type {Number}
       */
      userCertificateFailedCount: 0,

      /**
       * 生年月日選択リスト‐年
       * @type {List}
       */
      years: null,

      /**
       * 生年月日選択リスト‐月
       * @type {List}
       */
      months: null,

      /**
       * 生年月日選択リスト‐日
       * @type {List}
       */
      days: null,

      /**
       * ユーザ認証時の文言
       * @type {String}
       */
      userCertificateExplanation: this.$t('ご入力いただいた内容は、お客さまの契約確認に利用させていただきます。\n\n※当フォームは送信経路上のセキュリティ確保のために、暗号化してデータを送信する方式（SSL）を採用しております。\n※チャットのお問い合わせフォームから入力された内容は、お客さまのサポートにのみ利用されます。お客さまの許可なく、そのほかの目的に使用されることはございません。')
    }
  },
  beforeMount() {
    this.years = DateUtil.getYears(ChatConst.BIRTHDAY_YEAR_START)
    this.months = DateUtil.getMonths()
    this.days = DateUtil.getDays()
  },
  mounted() {
    // チャットユーザー情報のvalid状態を更新
    this.validateFastchatUserInfoForm((valid) => {
      this.validFastchatUserInfo = valid
    })
    // 年のスクロール調整
    this.setScrollPosition(this.$refs.yearSelect, 1997)
  },
  updated() {
    // チャットユーザー情報のvalid状態を更新
    this.validateFastchatUserInfoForm((valid) => {
      this.validFastchatUserInfo = valid
    })
  },
  computed: {
    /**
     * チャットユーザー情報フォームへの入力が可能か
     * @return {Boolean}
     */
    permissionInputFastchatUserInfoForm() {
      return !this.requestingFindFastchatServiceStatus && !this.disabled
    },
    /**
     * 「チャットを始める」の実行が可能か
     * @return {Boolean}
     */
    permissionChatJoin() {
      return !this.requestingFindFastchatServiceStatus && this.validFastchatUserInfo && !this.disabled
    }
  },
  methods: {
    /**
     * 生年月日のフォーカスイベント処理
     * @param  {FocusEvent} event
     */
    birthdayFocusHandler(event) {
      // IE11でポップアップの後ろの入力カーソルが見える為、フォーカスを外す
      if (event.srcElement != null) {
        event.srcElement.blur()
      }
    },

    /**
     * チャットユーザー情報フォームのvalidate処理
     * @param  {Function} callback
     */
    validateFastchatUserInfoForm(callback) {
      this.$refs['fastchatUserInfoForm'].validate((valid) => {
        callback(valid)
      })
    },
    /**
     * 「チャットを始める」処理
     */
    doChatJoin() {
      if (!this.permissionChatJoin) {
        return
      }
      this.validateFastchatUserInfoForm((valid) => {
        if (valid) {
          this.chatJoin()
        }
      })
    },
    /**
     * 「チャットを始める」処理
     */
    chatJoin() {
        ServiceUtil.request('findFastchatServiceStatusWithPreStartChat', null, {
        start: _ => {
          this.requestingFindFastchatServiceStatus = true
        },
        success: (responseData) => {
          if (responseData.status === ChatMessageConst.FASTCHAT_SERVICE_STATUS_QUIET_HOURS) {
            setTimeout(_ => {
              DialogUtil.showInfoDialog(responseData.message, _ => {
                this.$emit('chatWindowClose')
              })
            }, 0)
            return
          }
          this.$emit('chatJoin', this.getChatJoinParam())
        },
        error: (errorCode) => {
          DialogUtil.showErrorDialog(errorCode)
        },
        end: _ => {
          this.requestingFindFastchatServiceStatus = false
        }
      })
    },
    /**
     * ユーザ認証結果ダイアログを表示
     */
    showUserCertificateResultDialog() {
      this.userCertificateFailedCount = this.userCertificateFailedCount + 1
      this.$refs['userCertificateResultDialog'].showUserNoCertificateBtn = this.userCertificateFailedCount > 1
      this.showUserCertificateResultDialogFlg = true
    },
    /**
     * 「入力画面に戻る」ハンドラ
     */
    showUserCertificateHandler() {
      this.showUserCertificateResultDialogFlg = false
    },
    /**
     * 「基本情報の入力なしでチャットを始める」ハンドラ
     */
    showUserNoCertificateHandler() {
      this.showUserCertificateResultDialogFlg = false
      this.userCertificateFlg = false
    },

    /**
     * 「生年月日選択リスト‐年、月」変更ハンドラ
     */
    yearsMonthsChangeHandler() {
      this.fastchatUserInfo.day = null
      this.days = DateUtil.getDays(this.fastchatUserInfo.year, this.fastchatUserInfo.month)
    },

    /**
     * ユーザ認証モードを取得
     @return {String}
     */
    getUserCertificateMode() {
      // 認証なし
      let paramUserCertificateMode = '0'
      if (this.userCertificateFlg) {
        // 認証成功
        paramUserCertificateMode = '1'
      } else {
        if (this.userCertificateFailedCount > 0) {
          // 認証失敗
          paramUserCertificateMode = '2'
        }
      }
      return paramUserCertificateMode
    },

    /**
     * パラメータを取得
     @return {Object}
     */
    getChatJoinParam() {
      let param = {
        lnameKana: this.fastchatUserInfo.lnameKana,
        fnameKana: this.fastchatUserInfo.fnameKana,
        userCertificateMode: this.getUserCertificateMode()
      }
      if (this.getUserCertificateMode() === '1') {
        param['custTel'] = this.fastchatUserInfo.custTel
        param['birthday'] = new Date(this.fastchatUserInfo.month + '/' + this.fastchatUserInfo.day + '/' + this.fastchatUserInfo.year).getTime()
      }
      return param
    },

    /**
     * プルダウンのスクロールポジション調整
     */
    setScrollPosition(selector, val) {
      selector.handleMenuEnter = function() {
          const opt = selector.selected.value == null ? selector.getOption(val) : selector.selected
          selector.$nextTick(() => selector.scrollToOption(opt))
      }
    }
  }
}
</script>

<style scoped>
.fc-chat-join-pane {
  height: 0px;
}

.main-area {
  background-color: rgb(142, 211, 251);
  flex: 2;
}

.footer-area {
  padding: 10px;
  background: #99a9bf;
}

.chat-join-button {
  width: 100%;
}

.close-button {
  background: transparent;
  border: none;
  color: white;
}

.form-item {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/chatWindow/chatJoin/FcChatJoinPane.vue